var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTurnOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#888888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.58 23c5.863 0 10.615-4.925 10.615-11S17.443 1 11.58 1 .965 5.925.965 12 5.717 23 11.58 23zm4.658-13.398a1 1 0 10-1.596-1.204l-3.904 5.174-2.389-1.933a1 1 0 00-1.258 1.554l3.192 2.584a1 1 0 001.428-.175l4.527-6z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTurnOn);
export default __webpack_public_path__ + "static/media/ic-turn-on.de09f8dd1cba755bbd1238b12f199cde.svg";
export { ForwardRef as ReactComponent };